/**
 * Possible drawer positions.
 */
export const DRAWER_POSITIONS = {
    RIGHT: 'right',
    LEFT: 'left',
    TOP: 'top',
    BOTTOM: 'bottom',
} as const;

/**
 * Possible drawer size.
 */
export const DRAWER_SIZES = {
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
} as const;

/**
 * Data test id to query the overlay in RTL tests
 */
export const OVERLAY_DATA_TEST_ID = 'overlay-data-test-id';

/**
 * Drawer close button id to query the element in header
 */
export const DRAWER_CLOSE_BTN_ID = 'DrawerCloseBtnId';
